'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.blobDownloaderLinkWidget = function (navigatorModel, invert) {
	return mmWidgets.each(this, function () {
		if ((!invert && !navigatorModel.isBlobDownloadSupported()) || (invert && navigatorModel.isBlobDownloadSupported())) {
			this.remove();
		}

	});
};
